import { useRef, useEffect } from "react";
import Menu from "../components/Menu";
// import character_1 from '../assets/new-ui/characters/characters-1.png'
// import character_2 from '../assets/new-ui/characters/characters-2.png'
// import character_3 from '../assets/new-ui/characters/characters-3.png'
// import character_4 from '../assets/new-ui/characters/characters-4.png'
// import character_5 from '../assets/new-ui/characters/characters-5.png'
import bigShark from "../assets/new-ui/main/Zeus.gif";
// import EconomyFormula from "../components/economy/EconomyFormula";
// import EconomyGraph from "../components/economy/EconomyGraph";
import Roadmap from "../components/roadmap/Roadmap";
import CustomButton from "../components/CustomButton";
// import partnerGolden from '../assets/new-ui/main/partner-golden.png'
import discordIcon from "../assets/new-ui/main/discord-icon.png";
import telegramIcon from "../assets/new-ui/main/telegram-icon.png";
import twitterIcon from "../assets/new-ui/main/twitter-icon.png";
import substackIcon from "../assets/new-ui/main/substack-icon.png";
import ScrollTop from "../components/ScrollTop";
import { useHistory } from "react-router-dom";
import { useRouteRoadmap } from "../contexts/Context";
import ConnectWallet from "../components/ConnectWallet";
// import roadmapImg from '../assets/new-ui/main/roadmap-img.png'
// import roadmapImgMobile from '../assets/new-ui/main/roadmap-img-mobile.svg'
import HolysharksCGI from "../components/HolysharksCGI";
import Bubble from "../components/coral/Bubble";

import partner1 from "../assets/new-ui/partner-investor/AVStar.png";
import partner2 from "../assets/new-ui/partner-investor/bsc-news.svg";
import partner3 from "../assets/new-ui/partner-investor/CF-new.png";
import partner4 from "../assets/new-ui/partner-investor/chain-broker.png";
import partner5 from "../assets/new-ui/partner-investor/cryptodep.png";
import partner6 from "../assets/new-ui/partner-investor/Gagarin.png";
import partner7 from "../assets/new-ui/partner-investor/Gen-Shards.svg";
import partner8 from "../assets/new-ui/partner-investor/GenX.jpeg";
import partner9 from "../assets/new-ui/partner-investor/golden-sholver-new.png";
import partner10 from "../assets/new-ui/partner-investor/Pantera-new.png";
import partner11 from "../assets/new-ui/partner-investor/Square-new.png";
import partner12 from "../assets/new-ui/partner-investor/suzy.svg";
import partner13 from "../assets/new-ui/partner-investor/th.png";

import sharkModel from "../assets/new-ui/mint/Zeus-small.gif";
import purchaseIcon from "../assets/new-ui/about-nft/purchase-new.png";
import tradeIcon from "../assets/new-ui/about-nft/trade-new.png";
import playGameIcon from "../assets/new-ui/about-nft/playGame-new.png";
import Aphrodite from "../assets/new-ui/main/aphrodite.gif";

export default function Main() {
  const history = useHistory();
  const [routeRoadmap, setRouteRoadmap] = useRouteRoadmap();
  const refRoadmap = useRef();
  // const [character1Hover, setCharacter1Hover] = useState(false)
  // const [character2Hover, setCharacter2Hover] = useState(false)
  // const [character3Hover, setCharacter3Hover] = useState(false)
  // const [character4Hover, setCharacter4Hover] = useState(false)
  // const [character5Hover, setCharacter5Hover] = useState(false)

  useEffect(() => {
    if (routeRoadmap) {
      refRoadmap.current.scrollIntoView();
      setRouteRoadmap(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeRoadmap]);

  function mintNow() {
    history.push("/genesis-mystery-box");
  }

  function registerInvestor() {
    history.push("/register-investor");
  }

  return (
    <div className="pageContainer mainContainer">
      <Menu />
      <ScrollTop />
      <ConnectWallet />
      <HolysharksCGI />

      <div className="introduce">
        <div className="content">
          {/* <div>Introducing Series 1:</div>
          <div>Welcome the killer of the sea !</div>
          <div>In series 1, adorable, collectible, and valuable sharks will be available for sale on the Binance Smart Chain platform.</div> */}
          <CustomButton
            text={"MINT NOW"}
            textColor={"black"}
            fn={mintNow}
            type={"small"}
            transparent={false}
          />
        </div>
        <div className="social">
          <img
            src={twitterIcon}
            alt="social icon"
            onClick={() =>
              window.open("https://twitter.com/HolySharksNFT", "_blank")
            }
          />
          <img
            src={telegramIcon}
            alt="social icon"
            onClick={() => window.open("https://t.co/OnpdMj7fwM", "_blank")}
          />
          <img
            src={substackIcon}
            alt="social icon"
            onClick={() =>
              window.open("https://holysharks.substack.com/", "_blank")
            }
          />
          <img
            src={discordIcon}
            alt="social icon"
            onClick={() =>
              window.open("https://discord.gg/9B96cEqwWD", "_blank")
            }
          />
        </div>
      </div>

      <div className="sharksList"></div>
      {/* <div className='characters'>
        <div className='charactersElement'
          onMouseOver={() => {
            setCharacter1Hover(true)
          }} 
          onMouseOut={() => {
            setCharacter1Hover(false)
          }}
        >
          <img src={character_1} alt='characters' className={character1Hover ? 'characterHover' : 'characterNormal'} />
        </div>
        <div className='charactersElement'
          onMouseOver={() => {
            setCharacter2Hover(true)
          }} 
          onMouseOut={() => {
            setCharacter2Hover(false)
          }}
        >
          <img src={character_2} alt='characters' className={character2Hover ? 'characterHover' : 'characterNormal'}/>
        </div>
        <div className='charactersElement'
          onMouseOver={() => {
            setCharacter3Hover(true)
          }} 
          onMouseOut={() => {
            setCharacter3Hover(false)
          }}
        >
          <img src={character_3} alt='characters' className={character3Hover ? 'characterHover' : 'characterNormal'}/>
        </div>
        <div className='charactersElement'
          onMouseOver={() => {
            setCharacter4Hover(true)
          }} 
          onMouseOut={() => {
            setCharacter4Hover(false)
          }}
        >
          <img src={character_4} alt='characters' className={character4Hover ? 'characterHover' : 'characterNormal'}/>
        </div>
        <div className='charactersElement'
          onMouseOver={() => {
            setCharacter5Hover(true)
          }} 
          onMouseOut={() => {
            setCharacter5Hover(false)
          }}
        >
          <img src={character_5} alt='characters' className={character5Hover ? 'characterHover' : 'characterNormal'}/>
        </div>
      </div> */}

      <div className="nfts">
        <img src={bigShark} alt="big shark" />
        <div className="nftDescription">
          <div className="nftDescriptionContent">
            <div className="title">NFTs</div>
            <div className="description">
              Each Sharktopia will bring in its own characteristics and be
              randomly selected from given parts. The parts of Sharktopia will
              be sorted by rarity from common to unique. This ensures each
              Sharktopia is 1-of-a-kind in appearance and rarity completely
              different.
            </div>
            <div className="description">
              There is a limit to the number of Shark sold in this batch, and
              the only way to get it is through a completely random mint.
              Besides, Users can also buy and sell these NFTs on the
              marketplace.
            </div>
          </div>
        </div>
      </div>

      <div className="pageCenter">
        <div className="pageHeader">
          <img src={Aphrodite} alt="shark model" />
          <div className="headerDetail">
            <div className="headerDetailTitle">
              What exactly are Sharktopia?
            </div>
            <div className="headerDetailDescription">
              Holy Sharks are lovable and collectible 3d buddies that live and
              play on the BSC. There are only a limited number of sharks for
              sale in this series and no two Holy Sharks are identical. Lots of
              random properties and fun traits make each Holy Sharks cute,
              unique and sometimes rare. Sharks are encrypted into NFT and
              minted on BSC in the sale, so ownership of the Sharks is
              guaranteed Binance Smart Chain (BSC).
            </div>
            <ul>
              <li>Unique and individual HLS characters.</li>
              <li>
                Collectible value by creating artistic and unique shark NFTs.
              </li>
              <li>
                Tokenization and digitalization of NFTs items to trade in the
                Marketplaces.
              </li>
              <li>
                Create many mechanisms to expand the features for users Play to
                Earn. Delivering an exciting experience, more immersive,
                building on the gameplay evolving of NFTs in Ocean Economy.
              </li>
              <li>
                Unlock more possibilities and enable more relevant and immersive
                experiences in Sharktopia Metaverse.
              </li>
              <li>
                Stable Passive Income Revenue earning model for NFTs and HLS
                holders. Could boost the continual growth of Sharktopia value.
              </li>
            </ul>
          </div>
        </div>

        <div className="pageGuide">
          <Bubble top={"10%"} />
          <div className="guideTitle">HOW IT WORK</div>
          <div className="guideStepGroup">
            <div className="guideStep">
              <img src={purchaseIcon} alt="" />
              <div className="stepDetail">
                <div>Step 1</div>
                <div>Purchase NFTs</div>
                <div>
                  Buy Sharktopia NFTs during pre-sale event or from Marketplace.
                </div>
              </div>
            </div>

            <div className="guideStep">
              <img src={tradeIcon} alt="" />
              <div className="stepDetail">
                <div>Step 2</div>
                <div>Collect & Trade</div>
                <div>
                  Exchange and trade items between players to create a thriving
                  economy.
                </div>
              </div>
            </div>

            <div className="guideStep">
              <img src={playGameIcon} alt="" style={{ width: "320px" }} />
              <div className="stepDetail">
                <div>Step 3</div>
                <div>Play in Sharktopia Game</div>
                <div>Join the PVE, PVP game modes to get more rewards.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="roadmap" ref={refRoadmap}>
        <div className="roadmapTitle">ROAD MAP</div>
        <Roadmap />
        {/* <img src={roadmapImg} alt='roadmap' className='roadmapImg' />
        <img src={roadmapImgMobile} alt='roadmap' className='roadmapImgMobile' /> */}
      </div>

      <div className="footer">
        <Bubble bottom={"5%"} />
        <div className="footerTitle">OUR PARTNERS & INVESTORS</div>
        <div className="partner">
          <div className="partnerRow">
            {/* <img src={partnerGolden} alt='partner logo' /> */}
            <div className="partnerBox">
              <img src={partner1} alt="partner logo" />
            </div>
            <div className="partnerBox">
              <img src={partner7} alt="partner logo" />
            </div>
            {/* <div className='partnerComing'>Will be announced soon...</div>
            <div className='partnerComing'>Will be announced soon...</div> */}
          </div>
          <div className="partnerRow">
            {/* <div className='partnerComing'>Will be announced soon...</div>
            <div className='partnerComing'>Will be announced soon...</div> */}
            <div className="partnerBox">
              <img src={partner3} alt="partner logo" />
            </div>
            <div className="partnerBox">
              <img src={partner9} alt="partner logo" />
            </div>
          </div>
          <div className="partnerRow">
            {/* <div className='partnerComing'>Will be announced soon...</div>
            <div className='partnerComing'>Will be announced soon...</div> */}
            <div className="partnerBox">
              <img src={partner11} alt="partner logo" />
            </div>
            <div className="partnerBox">
              <img src={partner10} alt="partner logo" />
            </div>
          </div>
          <div className="partnerRow">
            <div className="partnerBox">
              <img src={partner4} alt="partner logo" />
            </div>
            <div className="partnerBox">
              <img src={partner8} alt="partner logo" />
            </div>
          </div>
          <div className="partnerRow">
            <div className="partnerBox">
              <img src={partner5} alt="partner logo" />
            </div>
            <div className="partnerBox">
              <img src={partner6} alt="partner logo" />
            </div>
          </div>
          <div className="partnerRow">
            <div className="partnerBox">
              <img src={partner12} alt="partner logo" />
            </div>
            <div className="partnerBox">
              <img src={partner13} alt="partner logo" />
            </div>
          </div>
          <div className="partnerRow">
            <div className="partnerBox">
              <img src={partner2} alt="partner logo" />
            </div>
          </div>
        </div>
        {/* <div className='footerDescription'>Will be announced soon...</div> */}
        <div className="footerBtn">
          <CustomButton
            text={"BECOME OUR INVESTOR"}
            textColor={"black"}
            fn={registerInvestor}
            type={"large"}
            transparent={false}
          />
        </div>
        <div className="footerBrand">@Sharktopia 2021</div>
      </div>
    </div>
  );
}
